import { LegalClientSaveRegistrationAddressesParam } from 'api/types/params';

import { CompanyAddressFormType } from '../../forms/companyAddressForm';

export const getSubmitData = (
  values: CompanyAddressFormType
): LegalClientSaveRegistrationAddressesParam => {
  const legalAddress = {
    country: values.countryLegal?.id!,
    region: values.regionLegal,
    apartment: values.apartmentLegal,
    building: values.housingLegal,
    district: values.areaLegal,
    house: values.houseNumberLegal,
    locality: values.localityLegal,
    postalCode: values.postcodeLegal,
    street: values.streetLegal,
    confirmationFileIds: values.confirmationFileIds,
  };

  const { confirmationFileIds, ...forActualAddress } = legalAddress;
  const actualAddress = !values.actualAddressIsSame
    ? {
        country: values.countryActual?.id!,
        region: values.regionActual!,
        apartment: values.apartmentActual!,
        building: values.housingActual,
        district: values.areaActual,
        house: values.houseNumberActual!,
        locality: values.localityActual!,
        postalCode: values.postcodeActual!,
        street: values.streetActual!,
      }
    : forActualAddress;

  return {
    legalAddress,
    actualAddress: {
      ...actualAddress,
    },
  };
};
